export default getQueryExpression => ({
  getPathExpression: (path, value, isNegated) => {
    const mongoValue = getQueryExpression ? getQueryExpression(value) : value;
    if (isNegated) {
      return { [path.join('.')]: { $not: { $elemMatch: mongoValue } } };
    } else {
      return { [path.join('.')]: { $elemMatch: mongoValue } };
    }
  }
});
